import {getRefElement} from '@utils/refUtils';
import type {ReactNode, RefObject} from 'react';
import {Component} from 'react';

interface Props {
    contents: string;
    textRef: RefObject<HTMLDivElement>;
    onHeight(height: number): void;
}

export default class GalleryText extends Component<Props> {
    public componentDidMount() {
        setTimeout(() => {
            try {
                this.props.onHeight(getRefElement(this.props.textRef).offsetHeight);
            } catch (refError) {
                console.error(refError);
            }
        }, 1);
    }

    public render(): ReactNode {
        return (
            <div
                className="gallery_text"
                dangerouslySetInnerHTML={{__html: this.props.contents}}
                ref={this.props.textRef}
            />
        );
    }
}
